export default __webpack_public_path__ + "static/media/sm.993092dc.png";